import Vue from 'vue'
import VueRouter from 'vue-router'
import RecallHome from '@/components/RecallHome'
import RecallList from '@/components/RecallList'
import RecallDetails from '@/components/RecallDetails'
import RecallSearch from '@/components/RecallSearch'
import RecallNews from '@/components/RecallNews'
import RecallFAQ from '@/components/RecallFAQ'
import Contact from '@/components/Contact'
// import PrivacyPolicy from '@/components/PrivacyPolicy'
// import TermsConditions from '@/components/TermsConditions'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: RecallHome
    },
    {
      path: '/list/:year?',
      name: 'RecallList',
      props: true,
      component: RecallList
    },
    {
      path: '/recall/:id',
      name: 'RecallDetails',
      props: true,
      component: RecallDetails
    },
    {
      path: '/search/:name',
      name: 'RecallSearch',
      props: true,
      component: RecallSearch
    },
    {
      path: '/news/:name',
      name: 'RecallNews',
      props: true,
      component: RecallNews
    },
    {
      path: '/faq',
      name: 'RecallFAQ',
      component: RecallFAQ
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
    /*,
    {
      path: '/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/terms-conditions',
      name: 'TermsConditions',
      component: TermsConditions
    }
    */
  ],
  scrollBehavior (to, from, savedPosition) {
    let position = { x: 0, y: 0 }
    // Keep scroll position when using browser buttons
    if (savedPosition) {
      position = savedPosition
    }

    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(position)
      }, 200)
    })
  },
  mode: 'history'
})
